import Color from "color";

export function getContrastingColour(backgroundColour: string) {
    const color = Color(backgroundColour);
    return color.isDark() ? "#FFFFFF" : "#000000";
}
